import { Component, contentChildren, TemplateRef, viewChildren } from '@angular/core';

import { QueryBarItemComponent } from './query-bar-item/query-bar-item.component';

@Component({
  selector: 'soft-query-bar',
  standalone: true,
  imports: [],
  templateUrl: './query-bar.component.html',
  styleUrl: './query-bar.component.css',
})
export class QueryBarComponent {
  items = contentChildren(QueryBarItemComponent, {read: TemplateRef});
}
